export default "__VITE_ASSET__d493c00e__"